import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * ページが読み込まれた際「useLocation()」を利用して、
 * URL内に「#」がついているかの判定する。
 * 「#」が存在する場合、指定先までスクロールさせる。
 */
const useHashScroll = () => {
  const { hash } = useLocation();
  useEffect(() => {
    if (hash === '') {
      return;
    }

    const target = document.querySelector(`${decodeURIComponent(hash)}`);
    if (target !== null) {
      setTimeout(() => {
        target.scrollIntoView({ block: 'start' });
      }, 0);
    }
  }, [hash]);
};

export default useHashScroll;
